import { render, staticRenderFns } from "./reservationListComponent.vue?vue&type=template&id=87802dfe&scoped=true&"
import script from "./reservationListComponent.vue?vue&type=script&lang=js&"
export * from "./reservationListComponent.vue?vue&type=script&lang=js&"
import style0 from "./reservationListComponent.vue?vue&type=style&index=0&id=87802dfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87802dfe",
  null
  
)

export default component.exports